import React from "react";
import { Redirect, Route } from "react-router-dom";
import PropTypes from "prop-types";

const AuthenticatedRoute = ({ user, component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      user.isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect to="/sign-in" />
      )
    }
  />
);

AuthenticatedRoute.propTypes = {
  user: PropTypes.object.isRequired,
  component: PropTypes.any.isRequired,
};

export default AuthenticatedRoute;
